import { Libraries, LoadScriptNext } from '@react-google-maps/api';
import { LinearProgress } from '@mui/material';

import { SearchField as SearchFieldInput } from '@ocx/ui';

import { messages } from './store-locator.messages';

type SearchFieldProps = {
  googleMapsApiKey: string;
  onSearchSubmit: (search: string) => void;
};

const libraries: Libraries = ['places'];

export const SearchField = ({ googleMapsApiKey, onSearchSubmit }: SearchFieldProps) => {
  return (
    <LoadScriptNext
      libraries={libraries}
      googleMapsApiKey={googleMapsApiKey}
      loadingElement={<LinearProgress sx={{ opacity: 0.5, width: '100%' }} />}>
      <SearchFieldInput
        clearTriggersOnSubmit
        onSubmit={onSearchSubmit}
        placeholder={messages['localOffers:searchField:placeholderText']}
      />
    </LoadScriptNext>
  );
};
